import { defaultLocale } from '../app.constants';
import { JobColumn } from '../shared/models/job.model';
import { UserPreferences } from '../shared/models/user.model';
import { UserSettings } from '../shared/models/user-settings.model';

export const USER_SETTINGS_KEY = 'flywheelSettings';

export const defaultSessionSettings: Partial<UserSettings> = Object.freeze({
  showAllData: false,
});

export const defaultLocalSettings: Partial<UserSettings> = Object.freeze({
  dismissBrowserWarning: false,
  locale: defaultLocale,
  originalTimezones: false,
  runGearRulesOnMove: false,
});

export const defaultServerSettings: UserPreferences = Object.freeze({
  job_log_columns: Object.values(JobColumn),
  tasks_columns_disabled: [],
  task_manager_columns: [],
  task_manager_column_sort_order: null,
});

/**
 * The API accepts `task_manager_column_sort_order` only as `[column, 'asc' | 'desc']` or `null`.
 * Older clients stored `[column, null]` for a cleared sort, which the API rejects with a 422 on every preferences update.
 */
export function normalizeTaskManagerSortOrder(
  sortOrder: UserPreferences['task_manager_column_sort_order'],
): UserPreferences['task_manager_column_sort_order'] {
  const [column, direction] = sortOrder ?? [];
  return column && (direction === 'asc' || direction === 'desc') ? [column, direction] : null;
}

export function getLocalStorageSettings(): UserSettings {
  let localSettings: Partial<UserSettings>;
  try {
    localSettings = { ...defaultLocalSettings, ...JSON.parse(localStorage.getItem(USER_SETTINGS_KEY)) };
  } catch (error) {
    localSettings = defaultLocalSettings;
  }
  let sessionSettings: Partial<UserSettings>;
  try {
    sessionSettings = { ...defaultSessionSettings, ...JSON.parse(sessionStorage.getItem(USER_SETTINGS_KEY)) };
  } catch (error) {
    sessionSettings = defaultSessionSettings;
  }
  return { ...localSettings, ...sessionSettings } as UserSettings;
}

export function obscurePhoneNumber(phoneNumber): string {
  if (!phoneNumber) {
    return '';
  }
  const countryCode = phoneNumber.substring(0, 1);
  const firstNumber = phoneNumber.substring(1, 2);
  const lastTwoNumbers = phoneNumber.substring(phoneNumber.length - 2);
  const asterisks = '*'.repeat(phoneNumber.length - 4);
  return `${countryCode}${firstNumber}${asterisks}${lastTwoNumbers}`;
}
